//授权链接 正式
export const AUTH_WAYPAY_URL = "https://college.fs-salon.cn/";
export const AUTH_GLOBAL_URL = "https://college.fs-salon.cn/fsslh5/#/home";
export const ROOT_HTTP_BASEURL = "https://college.fs-salon.cn/"; //请求地址
export const AUTH_GLOBAL_COURSE_URL =
  "https://college.fs-salon.cn/fsslh5/#/play";
export const imageGlobalUrl = "https://college.fs-salon.cn";
//授权链接 测试
// export const AUTH_WAYPAY_URL = "https://collegetest.fs-salon.cn/";
// export const AUTH_GLOBAL_URL = "https://collegetest.fs-salon.cn/fsslh5/#/home";
// export const AUTH_GLOBAL_COURSE_URL =
//   "https://collegetest.fs-salon.cn/fsslh5/#/play";
// export const ROOT_HTTP_BASEURL = "https://collegetest.fs-salon.cn/"; //请求地址
// export const imageGlobalUrl = "https://collegetest.fs-salon.cn";

export const QUERY_COURSE_API = "api/Course/GetCourseInfo"; //获取课程信息
export const ADD_PLAYRECORD_API = "api/Video/AddVideoPlayRecord"; //上传播放记录
export const QUERY_ISBINDPHONEFORWX_API = "api/Profile/bindWxByPhone"; //微信授权后获取token
export const QUERY_COURSEEVALUTE_API = "api/Course/GetCourseEvaluate"; //获取课程评价信息
export const QUERY_COURSEVEDIO_API = "api/Course/GetCourseVideo"; //获取课程目录
export const QUERY_VEDIO_SIGN = "api/Video/Sign/1440"; //视频签名
export const SEND_SMSCODE_API = "api/ShortMessage/SendValidCodeNew"; //获取短信验证码
export const BIND_PHONE_API = "api/Profile/bindPhoneForWxNew"; //绑定手机
export const QUERY_COUPON_API = "api/Coupon/GetUserCouponGzh"; //获取用户优惠券信息
export const QUERY_DRAGON_API = "api/Account/dragon_ball_count"; //获取用户龙珠信息
export const QUERY_ACCESSTOKEN_API = "api/WechatLogin/authorizeOfGZH"; //微信授权后获取token
export const QUERY_PAYTOKEN_API = "api/Order/GetPayToken"; //获取支付令牌
export const CREATE_ORDER_API = "api/Order/saveOrderGZHNew"; //创建订单
export const QUERY_PHONEBIND_API = "api/Profile/getBindPhoneRelationNew"; //获取是否绑定手机号
export const CREATE_ORDERBYDRAGON_API = "api/Order/DragonPayNew"; //龙珠下单
export const QUERY_FREECOURSE_API = "api/Course/GetFreeCourses"; //获取免费课程列表
export const QUERY_RECOMMENDCOURSE_API = "api/CourseGzh/list"; //获取推荐课程列表
export const QUERY_MYCOURCE_API = "api/Course/getCourseSelfByType"; //获取我的课程列表

export const QUERY_USERINFO_API = "api/Account/UserInfo"; //获取用户信息
export const QUERY_AVAILABLE_API = "api/Coupon/findUserCoupon"; //查询用户可使用的优惠券(包含当前商品可使用的和当前商品不可使用的)
export const QUERY_USECOUPONPRICE_API = "api/Order/calculationProdPrice"; //根据选择的优惠券来计算价格
export const ADD_SHARERECORD_API = "api/share/shareRecord"; //增加分享次数
export const QUERY_COURSERECOMMEND_API = "api/Course/GetRelatedCourses"; //获取课程的推荐数据
